<template>
  <section class="notifications-center" dir="rtl">
    <header class="head">
      <h1>اطلاعیه ها و پیام های شخصی</h1>
      <p>در این صفحه می توانید اعلان های سیستم و پیام های شخصی خود را ببینید.</p>
    </header>

    <div class="tabs">
      <button type="button" class="tab-btn" :class="{ active: activeTab === 'notifications' }"
        @click="activeTab = 'notifications'">
        اطلاعیه ها
      </button>
      <button type="button" class="tab-btn" :class="{ active: activeTab === 'messages' }" @click="activeTab = 'messages'">
        پیام های شخصی
      </button>
    </div>

    <div v-if="activeTab === 'notifications'" class="panel">
      <article v-for="item in notifications" :key="item.id" class="row">
        <h3>{{ item.title }}</h3>
        <p>{{ item.body }}</p>
        <small>{{ item.time }}</small>
      </article>
    </div>

    <div v-else class="panel">
      <article v-for="item in personalMessages" :key="item.id" class="row">
        <h3>{{ item.from }}</h3>
        <p>{{ item.body }}</p>
        <small>{{ item.time }}</small>
      </article>
    </div>
  </section>
</template>

<script setup>
import { ref, onMounted } from "vue";

const NOTIFICATION_UNREAD_KEY = "notificationUnreadCount";
const activeTab = ref("notifications");

const notifications = ref([
  { id: 1, title: "بروزرسانی سیستم", body: "نسخه جدید سامانه با بهبود عملکرد منتشر شد.", time: "امروز 09:20" },
  { id: 2, title: "یادآوری", body: "تمدید اشتراک شما 3 روز دیگر انجام می شود.", time: "دیروز 17:10" },
]);

const personalMessages = ref([
  { id: 1, from: "پشتیبانی", body: "درخواست شما ثبت شد و در حال بررسی است.", time: "امروز 11:00" },
  { id: 2, from: "مدیر سیستم", body: "لطفا اطلاعات پروفایل را تکمیل کنید.", time: "دیروز 14:45" },
]);

onMounted(() => {
  localStorage.setItem(NOTIFICATION_UNREAD_KEY, "0");
  window.dispatchEvent(new Event("notification-unread-updated"));
});
</script>

<style scoped>
.notifications-center {
  width: min(980px, 100%);
  margin: 18px auto;
  padding: 20px;
  border-radius: 16px;
  background:
    linear-gradient(180deg,
      rgba(var(--background-color-button-rgb), 0.07) 0%,
      rgba(var(--background-color-button-rgb), 0.03) 100%),
    var(--background-color);
  border: 1px solid rgba(var(--text-color-secondary-rgb), 0.25);
}

.head h1 {
  margin: 0;
  color: var(--text-color-primary);
  font-size: 1.3rem;
}

.head p {
  margin: 8px 0 0;
  color: var(--text-color-secondary);
}

.tabs {
  margin-top: 18px;
  display: flex;
  gap: 8px;
}

.tab-btn {
  border: 1px solid rgba(var(--text-color-secondary-rgb), 0.3);
  border-radius: 10px;
  padding: 8px 14px;
  background: var(--background-color);
  color: var(--text-color-primary);
  font-weight: 700;
  cursor: pointer;
}

.tab-btn.active {
  background: var(--background-color-button);
  border-color: var(--background-color-button);
  color: #ffffff;
}

.panel {
  margin-top: 16px;
  display: grid;
  gap: 10px;
}

.row {
  background: var(--hover-background-color);
  border: 1px solid rgba(var(--text-color-secondary-rgb), 0.2);
  border-radius: 12px;
  padding: 12px;
}

.row h3 {
  margin: 0 0 6px;
  color: var(--text-color-primary);
  font-size: 1rem;
}

.row p {
  margin: 0 0 8px;
  color: var(--text-color-secondary);
}

.row small {
  color: var(--text-color-secondary);
}

@media (max-width: 768px) {
  .notifications-center {
    margin: 10px auto;
    padding: 14px;
  }

  .tabs {
    flex-wrap: wrap;
  }
}
</style>
